import React from "react";
import { FlexCenter } from "../../layout/FlexCenter/FlexCenter";
import { HeightWithBottomDistance } from "../../layout/HeightWithBottomDistance/HeightWithBottomDistance";
import { MinWidth } from "../../layout/MinWidth/MinWidth";
import { ScrollY } from "../../layout/Scroll/ScrollY";
import { SpacingCustom } from "../../layout/Spacing/SpacingCustom";

interface IDashbosrdMainListProps {
    children?: React.ReactNode,
    minWidth?: number,
    stretch?: boolean,
    hasDistance?: boolean,
    paddingTop?: number,
    scrollRef?: React.RefObject<HTMLDivElement>,
    isRelative?: boolean,
    hasScroll?: boolean,
    botomDistance?: number

}

export const DashboardLayout: React.FC<IDashbosrdMainListProps> = ({botomDistance = 9, children, hasScroll = true, hasDistance = true, minWidth = 850, stretch = false, paddingTop = 1, scrollRef, isRelative = false}) => {

    const content = (
        <SpacingCustom paddingLeft={1} paddingRight={1}>
            <FlexCenter position="center" gap={0.5}>
                <MinWidth stretch={stretch} width={minWidth}>{children}</MinWidth>
            </FlexCenter>
        </SpacingCustom>
    )

    return (
        <div style={{position: isRelative ? "relative" : "static"}}>
            <SpacingCustom paddingTop={paddingTop}>
                {
                    hasDistance
                    ?
                        hasScroll
                        ?
                        <HeightWithBottomDistance bottomDistance={botomDistance}>
                            <ScrollY ref={scrollRef}>{content}</ScrollY>
                        </HeightWithBottomDistance>
                        :
                        content
                    :
                    content
                }
            </SpacingCustom>
        </div>
    )
}